import { ContentSnippetWithPage, DocumentEntityType } from "@common/components/search/SearchResultList.types.ts";

export interface AdvancedDocumentSearchFilterModel {
    entityTitle: string;
    documentTitle: string;
    responsible: Array<string>;
    documentStatus: Array<string>;
    documentTypeIds: Array<string>;
    documentEntityTypes: Array<string>;
    contractPartyIds: Array<string>;
    onlyCurrentVersion: boolean;
    pageNumber: number;
    sortingDirection: "asc" | "desc";
    sortColumn: AdvancedDocumentSortColumn;
    searchString: string;
}

export interface AdvancedDocumentSearchResponse {
    results: Array<AdvancedDocumentSearchResultViewModel>;
    totalCount: number;
    hasMoreResults: boolean;
}

export interface AdvancedDocumentSearchResultViewModel {
    entityTitle: string;
    entityType: DocumentEntityType;
    contentSnippets: Array<ContentSnippetWithPage>;
    responsible: string;
    totalPages: number;
    hasMoreOccurrences: boolean;
    id: string;
    documentId: string;
    documentVersionId: string;
    versionNumber?: number;
    entityId: string;
    parentEntityType?: DocumentEntityType;
    parentEntityId?: string;
    parentEntityTitle?: string;
    documentTitle?: string;
    fileName?: string;
    documentDate: Date;
    isLink: boolean;
    link?: string;
}

export interface AdvancedDocumentSearchSorting {
    sortingDirection: "asc" | "desc";
    sortColumn: AdvancedDocumentSortColumn;
}

export enum AdvancedDocumentSortColumn {
    DocumentDate = 1,
    EntityTitle = 2,
    DocumentTitle = 3,
}
